/**
 * Funkcia pre generovanie autorizačnej hlavičky pre API požiadavky
 * Používa sa v service triedach pre zabezpečené API endpointy
 */

export default function authHeader() {
  // Získaj token priamo z localStorage
  const token = localStorage.getItem('token');

  if (token) {
    // Pre Node.js Express backend s Bearer token
    return { Authorization: 'Bearer ' + token };
  } else {
    return {};
  }
}
